/**
 * Capitaliza un nombre completo: "JUAN PÉREZ" → "Juan Pérez".
 * Convención del sistema Medicus (reunión 16/05): los nombres se muestran
 * en formato `Capitalize`, no en mayúsculas — el padrón viene en mayúsculas
 * porque Binary lo exige, pero la UI lo presenta humanizado.
 */
export function capitalizeName(s: string | null | undefined): string {
  if (!s) return '';
  return s
    .toLowerCase()
    .split(/(\s+)/)
    .map((w) => (w.trim() === '' ? w : w.charAt(0).toUpperCase() + w.slice(1)))
    .join('');
}

/**
 * Une nombre + apellido capitalizando ambos.
 *   capitalizeFullName("JUAN", "PÉREZ") → "Juan Pérez"
 *   capitalizeFullName("juan carlos", "del sol") → "Juan Carlos Del Sol"
 */
export function capitalizeFullName(
  nombres: string | null | undefined,
  apellido: string | null | undefined,
): string {
  return [capitalizeName(nombres), capitalizeName(apellido)].filter(Boolean).join(' ').trim();
}
